import styled from '@emotion/styled';
import {
  APPLE_STORE_LINK,
  ButtonNormalPrimarySmallCompact,
  ButtonNormalSecondarySmallCompact,
  PLAY_STORE_LINK,
  TextDisplayAlt,
  TextParagraph,
  token,
} from '@angeplus/prever-component-lib';
import { LinkWrapper } from '@angeplus/prever-component-lib/nextjs';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';

import { useOSInfo } from '../../../install-app/install-app.store';
import { AUTH } from '../../../routes';

type HubHeroProps = {
  children?: ReactNode;
};

export const HubHero = (props: HubHeroProps) => {
  const router = useRouter();
  const phonesImage = `${router.basePath}/assets/svg/hub-phones.svg`;

  const { isIOS } = useOSInfo();

  const handleDownloadApp = () => {
    if (isIOS) {
      window.location.assign(APPLE_STORE_LINK);
    } else {
      window.location.assign(PLAY_STORE_LINK);
    }
  };

  return (
    <HeroContainer id="inicio">
      <HeroContent>
        <HeroLeft>
          <TextDisplayAlt>Simplifique sua vida com o Angeplus</TextDisplayAlt>
          <StyledTextParagraph>
            O Angeplus conecta você ao seu plano <b>Angelus</b>. Acesse a
            Carteirinha Digital, Guia Médico e gerencie tudo de forma simples,
            rápida e segura.
          </StyledTextParagraph>
          <ButtonsContainer>
            <ButtonWrapper onClick={handleDownloadApp}>
              <ButtonNormalPrimarySmallCompact>
                Baixar o app Angeplus
              </ButtonNormalPrimarySmallCompact>
            </ButtonWrapper>
            <LinkWrapper href={AUTH}>
              <ButtonNormalSecondarySmallCompact className="button_secondary_alt">
                Entrar no Angeplus
              </ButtonNormalSecondarySmallCompact>
            </LinkWrapper>
          </ButtonsContainer>
          <StoreBadges>
            <LinkWrapper href={APPLE_STORE_LINK}>
              <AppleStoreImage
                src={`${router.basePath}/assets/img/app-store-button.png`}
                alt="Apple Store"
              />
            </LinkWrapper>
            <LinkWrapper href={PLAY_STORE_LINK}>
              <PlayStoreImage
                src={`${router.basePath}/assets/img/play-store-button.png`}
                alt="Play Store"
              />
            </LinkWrapper>
          </StoreBadges>
          {props.children}
        </HeroLeft>
        <HeroRight>
          <PhonesImage src={phonesImage} alt="Angeplus app screens" />
        </HeroRight>
      </HeroContent>
    </HeroContainer>
  );
};

const HeroContainer = styled.section`
  display: flex;
  align-items: center;
  background-color: ${token.colors.solidAngeplusForeground};
  padding-top: 66px;

  @media (min-width: 768px) {
    padding: 100px 64px;
    min-height: 600px;
  }
`;

const HeroContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${token.spacing.spacingLarge};
  align-items: center;
  width: 100%;
  padding: ${token.spacing.spacingLarge};

  @media (min-width: 968px) {
    grid-template-columns: 1fr 1fr;
    gap: ${token.spacing.spacingXxLarge};
  }
`;

const HeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingMedium};
  max-width: 100%;

  @media (min-width: 968px) {
    max-width: 600px;
  }
`;

const HeroRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  order: 0;
`;

const PhonesImage = styled.img`
  width: 100%;
  max-width: 600px;
  height: auto;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingSmall};

  @media (min-width: 968px) {
    flex-direction: row;
  }
`;

const StoreBadges = styled.div`
  display: flex;
  gap: ${token.spacing.spacingSmall};
  flex-wrap: wrap;
`;

const AppleStoreImage = styled.img`
  width: 100%;
  max-width: 150px;
  height: auto;
`;

const PlayStoreImage = styled.img`
  width: 100%;
  max-width: 150px;
  height: auto;
`;

const ButtonWrapper = styled.div`
  cursor: pointer;
  white-space: nowrap;
`;

const StyledTextParagraph = styled(TextParagraph)`
  color: white !important;
`;
